export default __webpack_public_path__ + "static/media/error.b58c8f98.jpg";